export enum GoogleDomain {
  Google = 'www.google.com',
  MyActivity = 'myactivity.google.com',
  MyAccount = 'myaccount.google.com',
  Wallet = 'wallet.google.com',
  Families = 'families.google.com',
  MyAdCenter = 'myadcenter.google.com',
}

const INDEX_PATTERN = '{{i}}'

class GoogleUrl {
  private url: string

  urlPattern: string

  constructor(url: string, urlPattern?: string) {
    this.url = url
    const pattern = urlPattern ?? url
    const escapedPattern = pattern.replace(/\?/g, '\\?')
    const regexPattern = escapedPattern.replace(INDEX_PATTERN, '[0-9]+')
    this.urlPattern = regexPattern
  }

  private isUrlSet(i: number | null): boolean {
    const windowLocationHref = window.location.href.replace(/\/$/, '')
    // eslint-disable-next-line security/detect-non-literal-regexp
    const urlPatternRegex = new RegExp(this.urlPattern)

    if (i !== 0 && !i) {
      return false
    }

    // Check that the url matches the pattern
    if (!urlPatternRegex.test(windowLocationHref)) {
      return false
    }

    // Check that the url has the correct index
    // eslint-disable-next-line security/detect-non-literal-regexp
    const hasCorrectIndexRegex = new RegExp(`(/u/${i}|authuser=${i})`)
    return hasCorrectIndexRegex.test(windowLocationHref)
  }

  format(i: number | null): string {
    const index = i ?? 0
    return this.url.replace(INDEX_PATTERN, index.toString())
  }

  navigateForUser(i: number | null): void {
    if (!this.isUrlSet(i)) {
      window.location.assign(this.format(i))
    }
  }
}

export const activityControlsUrl = new GoogleUrl(
  `https://${GoogleDomain.MyActivity}/u/${INDEX_PATTERN}/activitycontrols`,
)
export const birthdayUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/birthday`,
)
export const genderUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/gender`,
)
export const homeUrl = new GoogleUrl(
  `https://${GoogleDomain.Google}?authuser=${INDEX_PATTERN}`,
)
export const languageUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/language`,
)
export const managePaymentsDataUrl = new GoogleUrl(
  `https://${GoogleDomain.Wallet}/wallet/u/${INDEX_PATTERN}/settings/managepaymentsdata`,
  // Matches:
  // - https://wallet.google.com/wallet/settings/managepaymentsdata
  // - https://wallet.google.com/wallet/forbidden
  // - https://families.google.com/service-restricted?es=...&continue=...
  `https://(${GoogleDomain.Wallet}/wallet/u/${INDEX_PATTERN}/(settings/managepaymentsdata|forbidden)|${GoogleDomain.Families}/service-restricted.*)`,
)
export const myAdCenterUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAdCenter}/u/${INDEX_PATTERN}`,
  `https://${GoogleDomain.MyAdCenter}/u/${INDEX_PATTERN}/(home|personalizationoff|kids)`,
)
export const personalInfoUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/personal-info`,
)
export const searchLanguageAndRegionUrl = new GoogleUrl(
  `https://${GoogleDomain.Google}/u/${INDEX_PATTERN}/preferences?lang=1`,
)
export const sharedEndorsementsUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/shared-endorsements`,
)
export const mapsContributionsUrl = new GoogleUrl(
  `https://${GoogleDomain.Google}/maps/contrib/?authuser=${INDEX_PATTERN}`,
  `https://${GoogleDomain.Google}/maps/contrib/.*`,
)
export const profilePictureUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/personal-info`,
)
export const securityUrl = new GoogleUrl(
  `https://${GoogleDomain.MyAccount}/u/${INDEX_PATTERN}/security`,
)
